import { Table, Text } from '@mantine/core';
import React from 'react';
import { formatCurrency } from 'src/cashflows/utils';
import { formatDate } from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { FinancialRow } from './financialRows';
import { AssetFeedRowIcon } from 'src/financial/financial-data/AssetFeedIndicators';

const GRAY_1_BORDER = '1px solid var(--mantine-color-gray-1)';

export function FinancialRows({
  rows,
  showMember,
  onRowClick,
}: {
  rows: FinancialRow[];
  showMember: boolean;
  onRowClick?: (row: FinancialRow) => void;
}) {
  const columns = [
    ...(showMember ? ['Member'] : []),
    'Description',
    'Provider',
    'Type',
    'Balance date',
    'Balance',
  ];

  return (
    <Table
      withRowBorders={false}
      verticalSpacing={0}
      horizontalSpacing="md"
      styles={{ thead: { backgroundColor: 'transparent' } }}
    >
      <Table.Thead>
        <Table.Tr>
          {columns.map((column, index) => (
            <Table.Th
              key={column}
              style={{
                paddingBottom: 16,
                textAlign: index === columns.length - 1 ? 'right' : 'left',
              }}
            >
              <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.6">
                {column}
              </Text>
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.map(row => (
          <Table.Tr
            key={row.id}
            style={{ borderTop: GRAY_1_BORDER, cursor: onRowClick ? 'pointer' : undefined }}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
          >
            {showMember && <RowCell>{row.memberName}</RowCell>}
            <RowCell>
              {row.description || '—'}
              <AssetFeedRowIcon
                isUpdatedAutomatically={row.isUpdatedAutomatically}
                hasFeedData={row.hasFeedData}
              />
            </RowCell>
            <RowCell>{row.provider}</RowCell>
            <RowCell>{row.typeLabel}</RowCell>
            <RowCell>{row.balanceDate ? formatDate(row.balanceDate) : undefined}</RowCell>
            <RowCell align="right">
              {row.balance != null ? formatCurrency(row.balance) : undefined}
            </RowCell>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}

function RowCell({
  children,
  align = 'left',
}: {
  children: React.ReactNode;
  align?: 'left' | 'right';
}) {
  return (
    <Table.Td style={{ paddingTop: 16, paddingBottom: 20, textAlign: align }}>
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {children || '—'}
      </Text>
    </Table.Td>
  );
}
